// extracted by mini-css-extract-plugin
module.exports = {"btnEliminar":"styles_btnEliminar__3UI2u"};